// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"b6738707","209":"5d1b9e0b","484":"1bef058b","508":"19343943","629":"a6fc9f5f","851":"ec3ecaab","974":"2be7b50c"}[chunkId] + ".chunk.js";
};